module.exports = __webpack_public_path__ + "static/media/PA.4e7e9d78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PA.svg
// module id = 335
// module chunks = 0